import { render, staticRenderFns } from "./faq-question.vue?vue&type=template&id=8acca0e2"
import script from "./faq-question.vue?vue&type=script&lang=js"
export * from "./faq-question.vue?vue&type=script&lang=js"
import style0 from "./faq-question.vue?vue&type=style&index=0&id=8acca0e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports